import React from 'react';
import PropTypes from 'prop-types';
import { H2, H3, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import dollar from 'assets/images/promos/dollar.svg';
import useExperiment from 'hooks/useExperiment';
import './giftCardPill.scss';

export function GiftCardPill({ giftCardValue }) {
	const { sf15309Variation } = useExperiment('sf_15309_giftcard_incentives');
	return sf15309Variation === 'variation' ? (
		<div className="gift-card-pill">
			<Paragraph
				className="gift-card-add"
				color="green"
				size="standard"
			>
				+
			</Paragraph>
			<div className="gift-card-pill-text">
				<Image
					src={dollar}
					alt="dollar"
					className="gift-card-dollar"
				/>
				<H3
					className="gift-card-pill-text-content"
					family="rounded"
					color="white"
					size="tiny"
					weight="light"
				>
					${giftCardValue} Gift Card
				</H3>
			</div>
		</div>
	) : (
		<></>
	);
}

GiftCardPill.propTypes = {
	giftCardValue: PropTypes.number.isRequired,
};

export default GiftCardPill;
